<div class="min-h-screen">
  
  <header class="bg-white shadow p-4">
    <div class="container mx-auto flex justify-between items-center">
      <!-- <h1 class="text-2xl font-heading text-primary">UnifiedStaff</h1> -->
      <img src="assets/us-logo-nobg.png" alt="UnifiedStaff Logo" class="h-12" />
      <nav>
        <a href="#" class="text-neutral-700 hover:text-primary px-4">Features</a>
        <a routerLink="/login" class="text-indigo-600 hover:underline">Login</a>
        <button class="bg-primary text-white px-4 py-2 rounded shadow ml-4">Request Demo</button>
      </nav>
    </div>
  </header>
  <main>
    <router-outlet></router-outlet>
  </main>
  <footer class="text-center text-xs text-neutral-500 p-4">© 2025 UnifiedStaff</footer>
</div>
